/**
 * @module ol/interaction/Property
 */

/**
 * @enum {string}
 */
export default {
  ACTIVE: 'active'
};

//# sourceMappingURL=Property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/interaction/Property.js
// module id = 279
// module chunks = 0